import { render, staticRenderFns } from "./FormManagement.vue?vue&type=template&id=6ffe01ae&scoped=true&"
import script from "./FormManagement.vue?vue&type=script&lang=js&"
export * from "./FormManagement.vue?vue&type=script&lang=js&"
import style0 from "./FormManagement.vue?vue&type=style&index=0&id=6ffe01ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe01ae",
  null
  
)

export default component.exports